// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_privacy-policy_privacy-policy_module_ts":"8f3bf2371359d795","src_app_about_about_module_ts":"262d95602aa9a972","src_app_error_error_module_ts":"764e756dbae5981c"}[chunkId] + ".js";
};